/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class ViewOnlyService implements OnDestroy {

  isViewOnly: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private route: ActivatedRoute) {
    this.checkViewOnlyParam();
  }

  checkViewOnlyParam() {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(param => {
        let viewOnlyParam = false;
        if (param['viewOnly']) {
          viewOnlyParam = !!this.convertStringToBooleanParam(param['viewOnly']);
        }
        this.isViewOnly.next(viewOnlyParam);
      })
  }

  getIsViewOnly() {
    return this.isViewOnly.asObservable();
  }

  convertStringToBooleanParam(param: string) {
    if (param === 'true' || param === 'false') {
      return Boolean(JSON.parse(param));
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
